import { Navigate } from 'react-router-dom';

/**
 * RootRouter — `/`-routen är medvetet TOM och redirectar bara vidare:
 *
 *  - VITE_SPLASH_AS_DEFAULT=true → `/splash` (marketing-landing)
 *  - annars                     → `/flow-weaver` (huvud-appen)
 *
 * Detta håller `/`-uri:n stabil för bookmarks samtidigt som vi kan
 * toggla landningssidan utan kod-ändring (bara env-flag-flip).
 */
export default function RootRouter() {
  const splashIsDefault = import.meta.env.VITE_SPLASH_AS_DEFAULT === 'true';
  return <Navigate to={splashIsDefault ? '/splash' : '/flow-weaver'} replace />;
}
